import React, { Component } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import LocalStorageService from '../services/local-storage.service';
import RegisterForm from './register-form';
import Home from './home';
import Quiz from './quiz';
import ResultRound from './result-round';
import { challengeService, campaignService } from '../services';

class Game extends Component {
  campaignKey = 'covid-19';

  constructor(props) {
    super(props);

    this.state = {
      step: 'register',
      user: {
        name: '@username'
      },
      campaign: {
        name: '',
        description: '',
      },
      challenge: null,
      currentRound: 1,
      gameStarted: false,
    };
  }

  async componentDidMount() {
    let step = 'register';
    let campaign = await this.loadCampaign();
    let user = this.loadSession();
    let challenge = null;
    let currentRound = 1;

    if (user && campaign) {
      challenge = await this.loadChallenge(user._id, campaign._id);
      step = 'start';
    } else if (!user) {
      user = this.state.user;
    }

    if (challenge) {
      for (let i = 0; i < challenge.rounds.length; i++) {
        if (challenge.rounds[i].stats.length) {
          currentRound = i + 1;
        }
      }
    }

    this.setState({
      step,
      campaign,
      user,
      challenge,
      currentRound,
    });
  }

  loadSession = () => {
    try {
      let session = LocalStorageService.get('session');
      if (session && session.token && session.user) {
        return session.user;
      } else {
        LocalStorageService.clear();
        return null;
      }
    } catch (e) {
      console.log(e);
    }
  }

  loadCampaign = async () => {
    try {
      const response = await campaignService.getDetail(this.campaignKey);
      return response.data;
    } catch (e) {
      console.log(e);
    }
  }

  loadChallenge = async (userId, campaignId) => {
    let existChallenge = LocalStorageService.get('challenge');
    if (existChallenge) {
      return existChallenge;
    } else {
      return await this.generateChallenge(userId, campaignId);
    }
  }

  nextStepHandler = (step) => {
    this.setState({ step });
  }

  generateChallenge = async (userId, campaignId) => {
    try {
      const response = await challengeService.generate(userId, campaignId);
      LocalStorageService.set('challenge', response.data);
      return response.data;
    } catch(e) {
      console.log(e);
    }
  }

  registerSuccessfulHandler = async() => {
    let user = this.loadSession();
    let challenge = await this.generateChallenge(user._id, this.state.campaign._id);

    this.setState({
      user,
      challenge,
      step: 'start',
    });
  }

  startGameHandler = () => {
    let challenge = this.state.challenge;
    if  (challenge.rounds < 3) {
      this.onError('Ocurrio un error inseperado al iniciar su partida');
    } else {
      this.setState({
        step: 'start',
        gameStarted: true
      });
    }
  }

  startRoundHandler = () => {
    this.setState({
      step: 'quiz'
    });
  }

  toNextRound = () => {
    let currentRound = this.state.currentRound;

    this.setState({
      currentRound: currentRound + 1,
      step: 'start',
    });
  }

  completeRoundHandler = (statsRound) => {
    let round = this.state.currentRound - 1;
    let challenge = this.state.challenge;
    let roundCorrect = 0;
    let roundIncorrect = 0;
    let roundPoints = 0;

    for (let i = 0; i < statsRound.length; i++) {
      statsRound[i].isCorrect ? roundCorrect++ : roundIncorrect++ ;
      roundPoints += statsRound[i].points;
    }

    challenge.rounds[round].stats = statsRound;
    challenge.rounds[round].correct = roundCorrect;
    challenge.rounds[round].incorrect = roundIncorrect;
    challenge.rounds[round].points = roundPoints;
    challenge.points += roundPoints;

    if (this.state.currentRound == 3) {
      challenge.completed = true;
      this.saveChallengeResults(challenge);
    } else {
      LocalStorageService.set('challenge', challenge);
      this.setState({ 
        challenge,
        step: 'result' 
      });
    }
  }

  saveChallengeResults = async (challenge) => {
    try {
      const response = await challengeService.update(challenge);
      if (response.data) {
        LocalStorageService.remove('challenge');
        this.props.history.push(`/results/${challenge._id}`);
      }
    } catch (e) {
      console.log(e);
    }
  }

  onError = (message) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: '¡Oops!',
      text: message,
      icon: 'error',
      buttonsStyling: false,
    }).then(() => {
      LocalStorageService.clear();
      window.location.reload();
    });
  }

  _renderSection() {
    switch (this.state.step) {
      case 'start':
        return (
          <Home 
            username={this.state.user.name}
            campaign={this.state.campaign}
            started={this.state.gameStarted} 
            round={this.state.currentRound}
            startRound={this.startRoundHandler}
            startGame={this.startGameHandler}
          />
        );
      case 'quiz':
        return (
          <Quiz 
            completeRound={this.completeRoundHandler} 
            round={this.state.currentRound}
            questions={this.state.challenge.rounds[this.state.currentRound - 1].deckQuestions}
            campaign={this.state.campaign}
          />
        );
      case 'result':
        return (
          <ResultRound 
            round={this.state.currentRound}
            rounds={this.state.challenge.rounds}
            challengePoints={this.state.challenge.points}
            campaign={this.state.campaign}
            username={this.state.user.name}
            toNextRound={this.toNextRound}
          />
        );
      case 'register':
      default:
        return (
          <RegisterForm 
            campaign={this.state.campaign}
            registerCompleted={this.registerSuccessfulHandler} 
          />
        );
    }
  }

  render() {
    return (
      <>
      {this._renderSection()}
      </>
    );
  }
}

export default Game;